import React from 'react';
import { T } from '@tolgee/react';
import { TrackingTruck } from '../orderTracking.interface';
import TruckRow from './TruckRow';

interface TruckListProps {
	trucks: TrackingTruck[];
	selectedTruckId?: number;
	onToggle: (truckId: number) => void;
	onClearSelection: () => void;
	collapsible?: boolean;
	onOpenDocuments?: (truckId: number) => void;
}

const TruckList: React.FC<TruckListProps> = ({
	trucks,
	selectedTruckId,
	onToggle,
	onClearSelection,
	collapsible = true,
	onOpenDocuments,
}) => (
	<section className="px-4 sm:px-7 py-[22px]">
		<div className="flex items-center justify-between mb-3">
			<h2 className="m-0 text-[15px] font-bold text-track-ink">
				<T keyName="orderTracking.executionProgress">
					Order execution progress
				</T>
			</h2>
			{collapsible && selectedTruckId !== undefined ? (
				<button
					type="button"
					onClick={onClearSelection}
					className="border-none bg-transparent p-0 font-[inherit] text-[13px] font-semibold text-track-link cursor-pointer transition hover:text-track-link-hover hover:underline"
				>
					<T keyName="orderTracking.showAllTrucks">Show all trucks</T>
				</button>
			) : null}
		</div>
		<div className="flex flex-col">
			{!trucks.length ? (
				<div className="text-sm text-track-muted py-2">
					<T keyName="orderTracking.noTrucks">
						No trucks assigned to this order yet
					</T>
				</div>
			) : null}
			{trucks.map((truck) => (
				<TruckRow
					key={truck.id}
					truck={truck}
					expanded={truck.id === selectedTruckId}
					onToggle={onToggle}
					collapsible={collapsible}
					onOpenDocuments={onOpenDocuments}
				/>
			))}
		</div>
	</section>
);

export default TruckList;
